import React from 'react';
import { NavLink } from 'react-router-dom';

const PageSubBar = (props) => {
  const { items } = props;

  return (
    <div className="cs-bg--light">
      <div className="o-page-subbar row align-middle">
        <ul className="o-page-subbar__menu">
          { pageSubBarItems(items) }
        </ul>
      </div>
    </div>
  );
};

const pageSubBarItems = (items) => {
  return items.map((item, idx) => {
    return (
      <li key={`page-sub-bar-${idx}`}>
        <NavLink to={item.path} activeClassName='o-page-subbar__item--active' className='o-page-subbar__item'>
          { item.label }
        </NavLink>
      </li>
    );
  });
}


export default PageSubBar;
